import { createSelector } from 'reselect'

import { IRootState } from '../../root'

export const selectGlobalDeliveryDaysState = (state: IRootState) => state.order.globalDeliveryDays

export const selectGlobalDeliveryDays = createSelector(
  selectGlobalDeliveryDaysState,
  (state) => state.items,
)
